import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import PulseBar from './PulseBar';
import RealTimeLowStockBanner from '../inventory/RealTimeLowStockBanner';

const DashboardLayout: React.FC = () => {
    return (
        <div className="flex h-screen w-screen bg-gray-50 overflow-hidden">
            {/* Left Column: Sidebar (Fixed Width) */}
            <div className="w-[250px] flex-shrink-0 h-full">
                <Sidebar />
            </div>

            {/* Right Column: Pulse Bar + Main Content */}
            <div className="flex-1 flex flex-col h-full overflow-hidden">
                {/* Top: Pulse Bar */}
                <div className="flex-shrink-0 z-10">
                    <PulseBar />
                    <RealTimeLowStockBanner />
                </div>

                {/* Main Content Area (Scrollable) */}
                <main className="flex-1 overflow-auto bg-slate-50 relative p-6 md:p-8">
                    <Outlet />
                </main>
            </div>
        </div>
    );
};

export default DashboardLayout;
